/**
 * SourcesList Component
 * Displays list of sources with proper attribution
 */

import { Source } from '@/lib/validators';

interface SourcesListProps {
  sources: Source[];
}

export default function SourcesList({ sources }: SourcesListProps) {
  if (!sources || sources.length === 0) {
    return (
      <p className="text-gray-500 text-sm">No sources available.</p>
    );
  }

  return (
    <ul className="space-y-2">
      {sources.map((source, index) => (
        <li key={index} className="flex items-start space-x-3">
          <span className="flex-shrink-0 w-6 h-6 bg-primary-100 text-primary-700 rounded-full flex items-center justify-center text-xs font-bold">
            {index + 1}
          </span>
          <div className="flex-1">
            <a
              href={source.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 hover:text-primary-700 underline font-medium"
            >
              {source.label}
            </a>
            <p className="text-xs text-gray-500 break-all">{source.url}</p>
          </div>
        </li>
      ))}
    </ul>
  );
}

